import { WebFooter } from '@/components/web-footer'
import { WebTopHeader } from '@/components/web-top-header'
import { useClientOnly } from '@/hooks/useClientOnly'
import { GuardianLayout } from '../guardian'

interface Props {
  children: React.ReactNode
}

export const EnterpriseDetailLayout = ({ children }: Props): JSX.Element => {
  return (
    <GuardianLayout>
      <EnterpriseDetailLayoutInner>{children}</EnterpriseDetailLayoutInner>
    </GuardianLayout>
  )
}

function EnterpriseDetailLayoutInner(props: Props) {
  useClientOnly()
  return (
    <div className="grid-areas-enterprise-detail-layout">
      <WebTopHeader className="grid-area-header" />
      <article className="grid-area-content bg-basic-bg">
        {props.children}
      </article>
      <WebFooter className="grid-area-footer" />
    </div>
  )
}

export function getEnterpriseDetailLayout(page: React.ReactElement) {
  return <EnterpriseDetailLayout>{page}</EnterpriseDetailLayout>
}
